import { createContext } from 'react';

type FormContextType = {
    submitting: boolean;
    disabled: boolean;
    hasErrors: boolean;
    submit: () => void;
};

const FormContext = createContext<FormContextType>({
    submitting: false,
    disabled: false,
    hasErrors: false,
    submit: () => {},
});

export default FormContext;
